(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/envelope/assets/javascripts/components/concave-shadow.js') >= 0) return;  svs.modules.push('/components/tur/envelope/assets/javascripts/components/concave-shadow.js');
"use strict";

const {
  useEffect,
  useRef,
  useState
} = React;
const MAX_HEIGHT = 50;
const MAX_WIDTH = 366;
const MAX_OFFSET_X = 10;
const MAX_OFFSET_Y = 15;
const MAX_CONCAVE_DEPTH = 35;
const MAX_OFFSET_Y_SHADOW = 4;
const MAX_TOP_OFFSET = 30;
const createBeizerCurve = function (newCurveWidth, depth) {
  let offsetX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let offsetY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const newPoint1 = "".concat(0.25 * newCurveWidth, ",").concat(depth);
  const newPoint2 = "".concat(0.75 * newCurveWidth, ",").concat(depth);
  const newPoint3 = "".concat(newCurveWidth - offsetX, ",").concat(offsetY);
  return [newPoint1, newPoint2, newPoint3].join(' ');
};
const createPaths = newCurveWidth => {
  const scale = newCurveWidth / MAX_WIDTH;
  const height = Math.min(MAX_HEIGHT, MAX_HEIGHT * scale);
  const offsetX = Math.min(MAX_OFFSET_X, MAX_OFFSET_X * scale);
  const offsetY = Math.min(MAX_OFFSET_Y, MAX_OFFSET_Y * scale);
  const depth = Math.min(MAX_CONCAVE_DEPTH, MAX_CONCAVE_DEPTH * scale);
  return {
    concave: "M0,0 C".concat(createBeizerCurve(newCurveWidth, depth), " L").concat(newCurveWidth, ",").concat(height, " L0,").concat(height, " Z"),
    shadow: "M".concat(offsetX, ",").concat(offsetY, " C").concat(createBeizerCurve(newCurveWidth, depth, offsetX, offsetY), " L").concat(newCurveWidth, ",").concat(height, " L0,").concat(height, " Z")
  };
};
const getTopOffset = parentWidth => {
  const percentOfMaxWidth = parentWidth / MAX_WIDTH;
  return -Math.min(MAX_TOP_OFFSET, percentOfMaxWidth * MAX_TOP_OFFSET);
};
const getDropShadowFilter = parentWidth => {
  const scale = parentWidth / MAX_WIDTH;
  const offsetY = Math.min(MAX_OFFSET_Y_SHADOW, scale * MAX_OFFSET_Y_SHADOW);
  const blur = Math.min(MAX_OFFSET_Y_SHADOW, scale * MAX_OFFSET_Y_SHADOW);
  return "drop-shadow(0px ".concat(-offsetY, "px ").concat(blur, "px rgba(0, 0, 0))");
};
const ConcaveShadow = _ref => {
  let {
    parentRef,
    fillColor = 'white'
  } = _ref;
  const dropShadowRef = useRef(getDropShadowFilter(parentRef.current.offsetWidth));
  const topOffsetRef = useRef(getTopOffset(parentRef.current.offsetWidth));
  const [svgPaths, setSvgPaths] = useState(createPaths(parentRef.current.offsetWidth));
  useEffect(() => {
    const lazyOnResizeTicket = _.debounce(() => {
      const bodyWidth = parentRef.current.offsetWidth;
      dropShadowRef.current = getDropShadowFilter(bodyWidth);
      topOffsetRef.current = getTopOffset(bodyWidth);
      setSvgPaths(createPaths(bodyWidth));
    }, 10);
    window.addEventListener('resize', lazyOnResizeTicket);
    return () => {
      window.removeEventListener('resize', lazyOnResizeTicket);
    };
  }, []);
  return React.createElement("div", {
    className: "relative",
    style: {
      top: topOffsetRef.current,
      overflowX: 'clip'
    }
  }, React.createElement("div", {
    className: "absolute w100",
    style: {
      filter: dropShadowRef.current
    }
  }, React.createElement("svg", {
    className: "absolute w100 u-left-50 u-translate-middle-x"
  }, React.createElement("path", {
    d: svgPaths.shadow
  }))), React.createElement("svg", {
    className: "absolute w100 u-left-50 u-translate-middle-x"
  }, React.createElement("path", {
    d: svgPaths.concave,
    fill: fillColor
  })));
};
setGlobal('svs.tur.envelope.components.ConcaveShadow', ConcaveShadow);

 })(window);